import React from "react";

import "./TextArea.scss";

const TextArea = ({
    id,
    className = ".",
    text,
    name,
    value,
    placeholder,
    onChange,
    show,
}) => {
    return (
        <div className={`TextArea ${className}`}>
            {text && <span className="title-textarea">{text}</span>}
            <textarea
                id={id}
                className={`cs-textarea ${show ? "error-color" : ""}`}
                name={name}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
            />
        </div>
    );
};

export default TextArea;
